import { MessageCircle, Calendar, Users, ArrowRight } from "lucide-react"

export default function WidgetGrid() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 auto-rows-fr">
      {/* Row 1 */}

      {/* 1. Dodgeball Pattern Widget */}
      <div className="bg-[#E67E22] rounded-3xl p-6 flex items-center justify-center relative overflow-hidden min-h-[140px] reveal">
        <div className="text-white font-bold text-sm transform -rotate-12 text-center">
          <div className="space-y-1">
            <div>Dodgeball</div>
            <div>Dodgeball</div>
            <div>Dodgeball</div>
          </div>
        </div>
        <div className="absolute bottom-3 right-3 w-8 h-8 bg-white rounded-full flex items-center justify-center">
          <span className="text-[#E67E22] font-bold text-xs">GD</span>
        </div>
      </div>

      {/* 2. WhatsApp Widget */}
      <div className="bg-[#25D366] rounded-3xl p-6 flex items-center justify-center min-h-[140px] cursor-pointer hover:bg-[#20B858] transition-colors reveal">
        <MessageCircle className="h-10 w-10 text-white" />
      </div>

      {/* 3. Upcoming Events Widget */}
      <div className="bg-white rounded-3xl p-6 flex flex-col justify-between min-h-[140px] shadow-lg reveal">
        <div className="flex items-center gap-2 mb-3">
          <Calendar className="h-5 w-5 text-[#E67E22]" />
          <span className="font-semibold text-black text-sm">Upcoming (10)</span>
        </div>
        <div className="flex-1 space-y-2">
          <div className="bg-[#F5E6D3] rounded-lg px-3 py-2">
            <p className="text-[#E67E22] font-semibold text-xs">03:30 PM</p>
            <p className="text-black text-xs truncate">Tuesday's ACLO...</p>
          </div>
          <div className="bg-[#F5E6D3] rounded-lg px-3 py-2">
            <p className="text-[#E67E22] font-semibold text-xs">02:00 PM</p>
            <p className="text-black text-xs truncate">Saturday's Open...</p>
          </div>
        </div>
        <div className="text-right mt-3">
          <button className="text-[#E67E22] text-xs font-medium hover:underline">View All</button>
        </div>
      </div>

      {/* 4. Dodgeball Clinic Widget - spans 2 rows */}
      <div className="bg-white rounded-3xl p-6 flex flex-col justify-between row-span-2 min-h-[300px] shadow-lg reveal">
        <div>
          <h3 className="text-lg font-bold text-black mb-1">Dodgeball</h3>
          <h3 className="text-lg font-bold text-black mb-2">Clinic</h3>
          <p className="text-gray-600 text-sm mb-6">Fast. Fun. Fierce.</p>
        </div>
        <div>
          <div className="space-y-3 mb-6">
            <p className="text-[#E67E22] font-semibold text-sm">15+ players</p>
            <p className="text-black text-sm">
              from <span className="text-[#E67E22] font-bold">€15 pp</span>
            </p>
            <p className="text-black text-sm">
              <span className="text-[#E67E22] font-semibold">90+ min</span> session
            </p>
            <p className="text-black text-sm">
              Equipment <span className="text-[#E67E22] font-semibold">included</span>
            </p>
          </div>
          <button className="text-[#E67E22] font-medium hover:underline flex items-center gap-1 text-sm">
            Request <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </div>

      {/* Row 2 */}

      {/* 5. Discord Widget */}
      <div className="bg-[#533AFD] rounded-3xl p-6 flex items-center justify-center min-h-[140px] cursor-pointer hover:bg-[#4A32E6] transition-colors reveal">
        <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center">
          <Users className="h-6 w-6 text-[#533AFD]" />
        </div>
      </div>

      {/* 6. Pricing Widget - spans 2 columns */}
      <div className="bg-[#E67E22] rounded-3xl p-6 col-span-2 relative overflow-visible flex items-center justify-center min-h-[140px] reveal">
        <div className="bg-white rounded-2xl p-6 w-full max-w-[320px] text-center shadow-xl">
          <p className="text-xs font-bold uppercase text-gray-700 mb-3">Drop in Dodger</p>
          <p className="text-3xl font-bold text-black mb-4">€12.50</p>
          <div className="space-y-3">
            <button className="bg-black text-white font-bold px-6 py-3 rounded-full text-sm hover:bg-gray-800 transition-colors w-full">
              BUY NOW
            </button>
            <div className="flex gap-2">
              <button className="bg-[#F5E6D3] text-gray-700 font-medium px-4 py-2 rounded-full text-xs flex-1 hover:bg-gray-300 transition-colors">
                €40 Monthly
              </button>
              <button className="bg-[#F5E6D3] text-gray-700 font-medium px-4 py-2 rounded-full text-xs flex-1 hover:bg-gray-300 transition-colors">
                €325 Youth
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
